/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import React from 'react';
import { WidgetEditorOverlay } from '../WidgetEditorOverlay';
import { DragElement } from '../WidgetEditorToolbar/Components/DragElement';
import { DropElement } from '../WidgetEditorToolbar/Components/DropElement';
export const BaseWidgetEditorComponent = (props) => {
    const icon = props.widget.icon;
    const label = props.widgetLabelProvider ? props.widgetLabelProvider(props.widget.type) : props.widget.type;
    return (React.createElement(Box, { sx: Object.assign(Object.assign({}, props.sx), { position: 'relative' }) },
        props.children,
        React.createElement(WidgetEditorOverlay, { config: props.config, nestingLevel: props.nestingLevel, label: label, dragElement: React.createElement(DragElement, { icon: icon, label: label }), dropElement: React.createElement(DropElement, { icon: icon, label: label }), moveWidget: () => props.config, onEditWidget: props.onEditWidget }, props.editorOverlay)));
};
